import { c as _c } from "react/compiler-runtime";
type LogoProps = React.SVGAttributes<SVGElement>;
export function Logo(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M295 270H580C710 270 780 340 780 435C780 495 750 540 690 560C765 580 810 635 810 720C810 830 730 900 580 900H295V270ZM435 395V515H555C600 515 635 490 635 455C635 420 600 395 555 395H435ZM435 605V775H575C630 775 665 745 665 690C665 635 630 605 575 605H435Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="200 260 680 680" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}